// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v4.25.3
// source: messenger/messenger.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FileDescriptorProto as FileDescriptorProto1 } from "ts-proto-descriptors";
import { Empty, protoMetadata as protoMetadata1 } from "../google/protobuf/empty";

export const protobufPackage = "messenger";

/** Communication patterns supported */
export enum CommunicationType {
  ERROR = 0,
  REQUEST = 1,
  REPLY = 2,
  PUBLISH = 3,
  SUBSCRIBE = 4,
  STREAM = 5,
  UNRECOGNIZED = -1,
}

export function communicationTypeFromJSON(object: any): CommunicationType {
  switch (object) {
    case 0:
    case "ERROR":
      return CommunicationType.ERROR;
    case 1:
    case "REQUEST":
      return CommunicationType.REQUEST;
    case 2:
    case "REPLY":
      return CommunicationType.REPLY;
    case 3:
    case "PUBLISH":
      return CommunicationType.PUBLISH;
    case 4:
    case "SUBSCRIBE":
      return CommunicationType.SUBSCRIBE;
    case 5:
    case "STREAM":
      return CommunicationType.STREAM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CommunicationType.UNRECOGNIZED;
  }
}

export function communicationTypeToJSON(object: CommunicationType): string {
  switch (object) {
    case CommunicationType.ERROR:
      return "ERROR";
    case CommunicationType.REQUEST:
      return "REQUEST";
    case CommunicationType.REPLY:
      return "REPLY";
    case CommunicationType.PUBLISH:
      return "PUBLISH";
    case CommunicationType.SUBSCRIBE:
      return "SUBSCRIBE";
    case CommunicationType.STREAM:
      return "STREAM";
    case CommunicationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DefaultRequests {
  Ping = 0,
  GetServiceInfo = 1,
  UNRECOGNIZED = -1,
}

export function defaultRequestsFromJSON(object: any): DefaultRequests {
  switch (object) {
    case 0:
    case "Ping":
      return DefaultRequests.Ping;
    case 1:
    case "GetServiceInfo":
      return DefaultRequests.GetServiceInfo;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DefaultRequests.UNRECOGNIZED;
  }
}

export function defaultRequestsToJSON(object: DefaultRequests): string {
  switch (object) {
    case DefaultRequests.Ping:
      return "Ping";
    case DefaultRequests.GetServiceInfo:
      return "GetServiceInfo";
    case DefaultRequests.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Generic message envelope for routing and metadata */
export interface Envelope {
  messageId: string;
  messageType: string;
  communicationType: CommunicationType;
  payload: Uint8Array;
  timestampUs: number;
}

export interface ServiceInfo {
  serviceKey: string;
  requestPort: number;
  messageTypes: string[];
  topicPort: number;
  topicTypes: string[];
  providers: string[];
  sinkPort: number;
}

export interface ClientOptions {
  configPath?: string | undefined;
  registryPort?: number | undefined;
}

export interface ErrorResponse {
  error: Uint8Array;
}

/** Envelope for sink (PUSH/PULL) messages — packs metadata + payload into a single ZMQ frame */
export interface SinkEnvelope {
  topic: string;
  senderId: string;
  payload: Uint8Array;
  timestampUs: number;
}

/** Envelope for PUB/SUB messages — wraps payload with a send timestamp */
export interface TopicEnvelope {
  payload: Uint8Array;
  timestampUs: number;
}

export interface RequestTarget {
  host?: string | undefined;
  serviceKey: string;
}

export interface PingRequest {
}

export interface PingResponse {
  pong: boolean;
}

export interface ServiceInfoRequest {
}

export interface ServiceInfoResponse {
  serviceInfo: ServiceInfo | undefined;
}

export interface SinkMetrics {
  topic: string;
  msgCount: number;
  bytesTotal: number;
  sendFailures: number;
  latencyMeanUs: number;
  latencyMaxUs: number;
  periodMeanUs: number;
  periodMaxUs: number;
  periodStddevUs: number;
}

export interface TopicMetrics {
  topic: string;
  msgCount: number;
  bytesTotal: number;
  latencyMeanUs: number;
  latencyMaxUs: number;
  periodMeanUs: number;
  periodMaxUs: number;
  periodStddevUs: number;
}

/** Per-method request metrics (used for both sender and handler). */
export interface RequestMethodMetrics {
  method: string;
  msgCount: number;
  bytesTotal: number;
  latencyMeanUs: number;
  latencyMaxUs: number;
}

export interface MessengerMetrics {
  nodeName: string;
  uptimeMs: number;
  sinkPullers: SinkMetrics[];
  sinkPushers: SinkMetrics[];
  publishers: TopicMetrics[];
  subscribers: TopicMetrics[];
  reqSender: RequestMethodMetrics[];
  reqHandler: RequestMethodMetrics[];
  timeoutCount: number;
}

function createBaseEnvelope(): Envelope {
  return { messageId: "", messageType: "", communicationType: 0, payload: new Uint8Array(0), timestampUs: 0 };
}

export const Envelope: MessageFns<Envelope> = {
  encode(message: Envelope, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.messageId !== "") {
      writer.uint32(10).string(message.messageId);
    }
    if (message.messageType !== "") {
      writer.uint32(18).string(message.messageType);
    }
    if (message.communicationType !== 0) {
      writer.uint32(24).int32(message.communicationType);
    }
    if (message.payload.length !== 0) {
      writer.uint32(34).bytes(message.payload);
    }
    if (message.timestampUs !== 0) {
      writer.uint32(40).uint64(message.timestampUs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Envelope {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnvelope();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.messageId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messageType = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.communicationType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.payload = reader.bytes();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.timestampUs = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Envelope {
    return {
      messageId: isSet(object.messageId) ? globalThis.String(object.messageId) : "",
      messageType: isSet(object.messageType) ? globalThis.String(object.messageType) : "",
      communicationType: isSet(object.communicationType) ? communicationTypeFromJSON(object.communicationType) : 0,
      payload: isSet(object.payload) ? bytesFromBase64(object.payload) : new Uint8Array(0),
      timestampUs: isSet(object.timestampUs) ? globalThis.Number(object.timestampUs) : 0,
    };
  },

  toJSON(message: Envelope): unknown {
    const obj: any = {};
    if (message.messageId !== "") {
      obj.messageId = message.messageId;
    }
    if (message.messageType !== "") {
      obj.messageType = message.messageType;
    }
    if (message.communicationType !== 0) {
      obj.communicationType = communicationTypeToJSON(message.communicationType);
    }
    if (message.payload.length !== 0) {
      obj.payload = base64FromBytes(message.payload);
    }
    if (message.timestampUs !== 0) {
      obj.timestampUs = Math.round(message.timestampUs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Envelope>, I>>(base?: I): Envelope {
    return Envelope.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Envelope>, I>>(object: I): Envelope {
    const message = createBaseEnvelope();
    message.messageId = object.messageId ?? "";
    message.messageType = object.messageType ?? "";
    message.communicationType = object.communicationType ?? 0;
    message.payload = object.payload ?? new Uint8Array(0);
    message.timestampUs = object.timestampUs ?? 0;
    return message;
  },
};

function createBaseServiceInfo(): ServiceInfo {
  return { serviceKey: "", requestPort: 0, messageTypes: [], topicPort: 0, topicTypes: [], providers: [], sinkPort: 0 };
}

export const ServiceInfo: MessageFns<ServiceInfo> = {
  encode(message: ServiceInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.serviceKey !== "") {
      writer.uint32(10).string(message.serviceKey);
    }
    if (message.requestPort !== 0) {
      writer.uint32(16).int32(message.requestPort);
    }
    for (const v of message.messageTypes) {
      writer.uint32(26).string(v!);
    }
    if (message.topicPort !== 0) {
      writer.uint32(32).int32(message.topicPort);
    }
    for (const v of message.topicTypes) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.providers) {
      writer.uint32(50).string(v!);
    }
    if (message.sinkPort !== 0) {
      writer.uint32(56).int32(message.sinkPort);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServiceInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServiceInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.serviceKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.requestPort = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.messageTypes.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.topicPort = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.topicTypes.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.providers.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.sinkPort = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServiceInfo {
    return {
      serviceKey: isSet(object.serviceKey) ? globalThis.String(object.serviceKey) : "",
      requestPort: isSet(object.requestPort) ? globalThis.Number(object.requestPort) : 0,
      messageTypes: globalThis.Array.isArray(object?.messageTypes)
        ? object.messageTypes.map((e: any) => globalThis.String(e))
        : [],
      topicPort: isSet(object.topicPort) ? globalThis.Number(object.topicPort) : 0,
      topicTypes: globalThis.Array.isArray(object?.topicTypes)
        ? object.topicTypes.map((e: any) => globalThis.String(e))
        : [],
      providers: globalThis.Array.isArray(object?.providers)
        ? object.providers.map((e: any) => globalThis.String(e))
        : [],
      sinkPort: isSet(object.sinkPort) ? globalThis.Number(object.sinkPort) : 0,
    };
  },

  toJSON(message: ServiceInfo): unknown {
    const obj: any = {};
    if (message.serviceKey !== "") {
      obj.serviceKey = message.serviceKey;
    }
    if (message.requestPort !== 0) {
      obj.requestPort = Math.round(message.requestPort);
    }
    if (message.messageTypes?.length) {
      obj.messageTypes = message.messageTypes;
    }
    if (message.topicPort !== 0) {
      obj.topicPort = Math.round(message.topicPort);
    }
    if (message.topicTypes?.length) {
      obj.topicTypes = message.topicTypes;
    }
    if (message.providers?.length) {
      obj.providers = message.providers;
    }
    if (message.sinkPort !== 0) {
      obj.sinkPort = Math.round(message.sinkPort);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServiceInfo>, I>>(base?: I): ServiceInfo {
    return ServiceInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServiceInfo>, I>>(object: I): ServiceInfo {
    const message = createBaseServiceInfo();
    message.serviceKey = object.serviceKey ?? "";
    message.requestPort = object.requestPort ?? 0;
    message.messageTypes = object.messageTypes?.map((e) => e) || [];
    message.topicPort = object.topicPort ?? 0;
    message.topicTypes = object.topicTypes?.map((e) => e) || [];
    message.providers = object.providers?.map((e) => e) || [];
    message.sinkPort = object.sinkPort ?? 0;
    return message;
  },
};

function createBaseClientOptions(): ClientOptions {
  return { configPath: undefined, registryPort: undefined };
}

export const ClientOptions: MessageFns<ClientOptions> = {
  encode(message: ClientOptions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.configPath !== undefined) {
      writer.uint32(10).string(message.configPath);
    }
    if (message.registryPort !== undefined) {
      writer.uint32(16).int32(message.registryPort);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClientOptions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClientOptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.configPath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.registryPort = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClientOptions {
    return {
      configPath: isSet(object.configPath) ? globalThis.String(object.configPath) : undefined,
      registryPort: isSet(object.registryPort) ? globalThis.Number(object.registryPort) : undefined,
    };
  },

  toJSON(message: ClientOptions): unknown {
    const obj: any = {};
    if (message.configPath !== undefined) {
      obj.configPath = message.configPath;
    }
    if (message.registryPort !== undefined) {
      obj.registryPort = Math.round(message.registryPort);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClientOptions>, I>>(base?: I): ClientOptions {
    return ClientOptions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClientOptions>, I>>(object: I): ClientOptions {
    const message = createBaseClientOptions();
    message.configPath = object.configPath ?? undefined;
    message.registryPort = object.registryPort ?? undefined;
    return message;
  },
};

function createBaseErrorResponse(): ErrorResponse {
  return { error: new Uint8Array(0) };
}

export const ErrorResponse: MessageFns<ErrorResponse> = {
  encode(message: ErrorResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.error.length !== 0) {
      writer.uint32(10).bytes(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ErrorResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseErrorResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.error = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ErrorResponse {
    return { error: isSet(object.error) ? bytesFromBase64(object.error) : new Uint8Array(0) };
  },

  toJSON(message: ErrorResponse): unknown {
    const obj: any = {};
    if (message.error.length !== 0) {
      obj.error = base64FromBytes(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ErrorResponse>, I>>(base?: I): ErrorResponse {
    return ErrorResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ErrorResponse>, I>>(object: I): ErrorResponse {
    const message = createBaseErrorResponse();
    message.error = object.error ?? new Uint8Array(0);
    return message;
  },
};

function createBaseSinkEnvelope(): SinkEnvelope {
  return { topic: "", senderId: "", payload: new Uint8Array(0), timestampUs: 0 };
}

export const SinkEnvelope: MessageFns<SinkEnvelope> = {
  encode(message: SinkEnvelope, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.topic !== "") {
      writer.uint32(10).string(message.topic);
    }
    if (message.senderId !== "") {
      writer.uint32(18).string(message.senderId);
    }
    if (message.payload.length !== 0) {
      writer.uint32(26).bytes(message.payload);
    }
    if (message.timestampUs !== 0) {
      writer.uint32(32).uint64(message.timestampUs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SinkEnvelope {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSinkEnvelope();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.topic = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.senderId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.payload = reader.bytes();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.timestampUs = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SinkEnvelope {
    return {
      topic: isSet(object.topic) ? globalThis.String(object.topic) : "",
      senderId: isSet(object.senderId) ? globalThis.String(object.senderId) : "",
      payload: isSet(object.payload) ? bytesFromBase64(object.payload) : new Uint8Array(0),
      timestampUs: isSet(object.timestampUs) ? globalThis.Number(object.timestampUs) : 0,
    };
  },

  toJSON(message: SinkEnvelope): unknown {
    const obj: any = {};
    if (message.topic !== "") {
      obj.topic = message.topic;
    }
    if (message.senderId !== "") {
      obj.senderId = message.senderId;
    }
    if (message.payload.length !== 0) {
      obj.payload = base64FromBytes(message.payload);
    }
    if (message.timestampUs !== 0) {
      obj.timestampUs = Math.round(message.timestampUs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SinkEnvelope>, I>>(base?: I): SinkEnvelope {
    return SinkEnvelope.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SinkEnvelope>, I>>(object: I): SinkEnvelope {
    const message = createBaseSinkEnvelope();
    message.topic = object.topic ?? "";
    message.senderId = object.senderId ?? "";
    message.payload = object.payload ?? new Uint8Array(0);
    message.timestampUs = object.timestampUs ?? 0;
    return message;
  },
};

function createBaseTopicEnvelope(): TopicEnvelope {
  return { payload: new Uint8Array(0), timestampUs: 0 };
}

export const TopicEnvelope: MessageFns<TopicEnvelope> = {
  encode(message: TopicEnvelope, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.payload.length !== 0) {
      writer.uint32(10).bytes(message.payload);
    }
    if (message.timestampUs !== 0) {
      writer.uint32(16).uint64(message.timestampUs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopicEnvelope {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopicEnvelope();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.payload = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.timestampUs = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopicEnvelope {
    return {
      payload: isSet(object.payload) ? bytesFromBase64(object.payload) : new Uint8Array(0),
      timestampUs: isSet(object.timestampUs) ? globalThis.Number(object.timestampUs) : 0,
    };
  },

  toJSON(message: TopicEnvelope): unknown {
    const obj: any = {};
    if (message.payload.length !== 0) {
      obj.payload = base64FromBytes(message.payload);
    }
    if (message.timestampUs !== 0) {
      obj.timestampUs = Math.round(message.timestampUs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopicEnvelope>, I>>(base?: I): TopicEnvelope {
    return TopicEnvelope.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopicEnvelope>, I>>(object: I): TopicEnvelope {
    const message = createBaseTopicEnvelope();
    message.payload = object.payload ?? new Uint8Array(0);
    message.timestampUs = object.timestampUs ?? 0;
    return message;
  },
};

function createBaseRequestTarget(): RequestTarget {
  return { host: undefined, serviceKey: "" };
}

export const RequestTarget: MessageFns<RequestTarget> = {
  encode(message: RequestTarget, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.host !== undefined) {
      writer.uint32(10).string(message.host);
    }
    if (message.serviceKey !== "") {
      writer.uint32(18).string(message.serviceKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequestTarget {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestTarget();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.host = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.serviceKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestTarget {
    return {
      host: isSet(object.host) ? globalThis.String(object.host) : undefined,
      serviceKey: isSet(object.serviceKey) ? globalThis.String(object.serviceKey) : "",
    };
  },

  toJSON(message: RequestTarget): unknown {
    const obj: any = {};
    if (message.host !== undefined) {
      obj.host = message.host;
    }
    if (message.serviceKey !== "") {
      obj.serviceKey = message.serviceKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestTarget>, I>>(base?: I): RequestTarget {
    return RequestTarget.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestTarget>, I>>(object: I): RequestTarget {
    const message = createBaseRequestTarget();
    message.host = object.host ?? undefined;
    message.serviceKey = object.serviceKey ?? "";
    return message;
  },
};

function createBasePingRequest(): PingRequest {
  return {};
}

export const PingRequest: MessageFns<PingRequest> = {
  encode(_: PingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PingRequest {
    return {};
  },

  toJSON(_: PingRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PingRequest>, I>>(base?: I): PingRequest {
    return PingRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PingRequest>, I>>(_: I): PingRequest {
    const message = createBasePingRequest();
    return message;
  },
};

function createBasePingResponse(): PingResponse {
  return { pong: false };
}

export const PingResponse: MessageFns<PingResponse> = {
  encode(message: PingResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pong !== false) {
      writer.uint32(8).bool(message.pong);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PingResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePingResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.pong = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PingResponse {
    return { pong: isSet(object.pong) ? globalThis.Boolean(object.pong) : false };
  },

  toJSON(message: PingResponse): unknown {
    const obj: any = {};
    if (message.pong !== false) {
      obj.pong = message.pong;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PingResponse>, I>>(base?: I): PingResponse {
    return PingResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PingResponse>, I>>(object: I): PingResponse {
    const message = createBasePingResponse();
    message.pong = object.pong ?? false;
    return message;
  },
};

function createBaseServiceInfoRequest(): ServiceInfoRequest {
  return {};
}

export const ServiceInfoRequest: MessageFns<ServiceInfoRequest> = {
  encode(_: ServiceInfoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServiceInfoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServiceInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ServiceInfoRequest {
    return {};
  },

  toJSON(_: ServiceInfoRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ServiceInfoRequest>, I>>(base?: I): ServiceInfoRequest {
    return ServiceInfoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServiceInfoRequest>, I>>(_: I): ServiceInfoRequest {
    const message = createBaseServiceInfoRequest();
    return message;
  },
};

function createBaseServiceInfoResponse(): ServiceInfoResponse {
  return { serviceInfo: undefined };
}

export const ServiceInfoResponse: MessageFns<ServiceInfoResponse> = {
  encode(message: ServiceInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.serviceInfo !== undefined) {
      ServiceInfo.encode(message.serviceInfo, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServiceInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServiceInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.serviceInfo = ServiceInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServiceInfoResponse {
    return { serviceInfo: isSet(object.serviceInfo) ? ServiceInfo.fromJSON(object.serviceInfo) : undefined };
  },

  toJSON(message: ServiceInfoResponse): unknown {
    const obj: any = {};
    if (message.serviceInfo !== undefined) {
      obj.serviceInfo = ServiceInfo.toJSON(message.serviceInfo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServiceInfoResponse>, I>>(base?: I): ServiceInfoResponse {
    return ServiceInfoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServiceInfoResponse>, I>>(object: I): ServiceInfoResponse {
    const message = createBaseServiceInfoResponse();
    message.serviceInfo = (object.serviceInfo !== undefined && object.serviceInfo !== null)
      ? ServiceInfo.fromPartial(object.serviceInfo)
      : undefined;
    return message;
  },
};

function createBaseSinkMetrics(): SinkMetrics {
  return {
    topic: "",
    msgCount: 0,
    bytesTotal: 0,
    sendFailures: 0,
    latencyMeanUs: 0,
    latencyMaxUs: 0,
    periodMeanUs: 0,
    periodMaxUs: 0,
    periodStddevUs: 0,
  };
}

export const SinkMetrics: MessageFns<SinkMetrics> = {
  encode(message: SinkMetrics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.topic !== "") {
      writer.uint32(10).string(message.topic);
    }
    if (message.msgCount !== 0) {
      writer.uint32(16).uint64(message.msgCount);
    }
    if (message.bytesTotal !== 0) {
      writer.uint32(24).uint64(message.bytesTotal);
    }
    if (message.sendFailures !== 0) {
      writer.uint32(32).uint64(message.sendFailures);
    }
    if (message.latencyMeanUs !== 0) {
      writer.uint32(40).uint64(message.latencyMeanUs);
    }
    if (message.latencyMaxUs !== 0) {
      writer.uint32(48).uint64(message.latencyMaxUs);
    }
    if (message.periodMeanUs !== 0) {
      writer.uint32(56).uint64(message.periodMeanUs);
    }
    if (message.periodMaxUs !== 0) {
      writer.uint32(64).uint64(message.periodMaxUs);
    }
    if (message.periodStddevUs !== 0) {
      writer.uint32(72).uint64(message.periodStddevUs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SinkMetrics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSinkMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.topic = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.msgCount = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.bytesTotal = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.sendFailures = longToNumber(reader.uint64());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.latencyMeanUs = longToNumber(reader.uint64());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.latencyMaxUs = longToNumber(reader.uint64());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.periodMeanUs = longToNumber(reader.uint64());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.periodMaxUs = longToNumber(reader.uint64());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.periodStddevUs = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SinkMetrics {
    return {
      topic: isSet(object.topic) ? globalThis.String(object.topic) : "",
      msgCount: isSet(object.msgCount) ? globalThis.Number(object.msgCount) : 0,
      bytesTotal: isSet(object.bytesTotal) ? globalThis.Number(object.bytesTotal) : 0,
      sendFailures: isSet(object.sendFailures) ? globalThis.Number(object.sendFailures) : 0,
      latencyMeanUs: isSet(object.latencyMeanUs) ? globalThis.Number(object.latencyMeanUs) : 0,
      latencyMaxUs: isSet(object.latencyMaxUs) ? globalThis.Number(object.latencyMaxUs) : 0,
      periodMeanUs: isSet(object.periodMeanUs) ? globalThis.Number(object.periodMeanUs) : 0,
      periodMaxUs: isSet(object.periodMaxUs) ? globalThis.Number(object.periodMaxUs) : 0,
      periodStddevUs: isSet(object.periodStddevUs) ? globalThis.Number(object.periodStddevUs) : 0,
    };
  },

  toJSON(message: SinkMetrics): unknown {
    const obj: any = {};
    if (message.topic !== "") {
      obj.topic = message.topic;
    }
    if (message.msgCount !== 0) {
      obj.msgCount = Math.round(message.msgCount);
    }
    if (message.bytesTotal !== 0) {
      obj.bytesTotal = Math.round(message.bytesTotal);
    }
    if (message.sendFailures !== 0) {
      obj.sendFailures = Math.round(message.sendFailures);
    }
    if (message.latencyMeanUs !== 0) {
      obj.latencyMeanUs = Math.round(message.latencyMeanUs);
    }
    if (message.latencyMaxUs !== 0) {
      obj.latencyMaxUs = Math.round(message.latencyMaxUs);
    }
    if (message.periodMeanUs !== 0) {
      obj.periodMeanUs = Math.round(message.periodMeanUs);
    }
    if (message.periodMaxUs !== 0) {
      obj.periodMaxUs = Math.round(message.periodMaxUs);
    }
    if (message.periodStddevUs !== 0) {
      obj.periodStddevUs = Math.round(message.periodStddevUs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SinkMetrics>, I>>(base?: I): SinkMetrics {
    return SinkMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SinkMetrics>, I>>(object: I): SinkMetrics {
    const message = createBaseSinkMetrics();
    message.topic = object.topic ?? "";
    message.msgCount = object.msgCount ?? 0;
    message.bytesTotal = object.bytesTotal ?? 0;
    message.sendFailures = object.sendFailures ?? 0;
    message.latencyMeanUs = object.latencyMeanUs ?? 0;
    message.latencyMaxUs = object.latencyMaxUs ?? 0;
    message.periodMeanUs = object.periodMeanUs ?? 0;
    message.periodMaxUs = object.periodMaxUs ?? 0;
    message.periodStddevUs = object.periodStddevUs ?? 0;
    return message;
  },
};

function createBaseTopicMetrics(): TopicMetrics {
  return {
    topic: "",
    msgCount: 0,
    bytesTotal: 0,
    latencyMeanUs: 0,
    latencyMaxUs: 0,
    periodMeanUs: 0,
    periodMaxUs: 0,
    periodStddevUs: 0,
  };
}

export const TopicMetrics: MessageFns<TopicMetrics> = {
  encode(message: TopicMetrics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.topic !== "") {
      writer.uint32(10).string(message.topic);
    }
    if (message.msgCount !== 0) {
      writer.uint32(16).uint64(message.msgCount);
    }
    if (message.bytesTotal !== 0) {
      writer.uint32(24).uint64(message.bytesTotal);
    }
    if (message.latencyMeanUs !== 0) {
      writer.uint32(32).uint64(message.latencyMeanUs);
    }
    if (message.latencyMaxUs !== 0) {
      writer.uint32(40).uint64(message.latencyMaxUs);
    }
    if (message.periodMeanUs !== 0) {
      writer.uint32(48).uint64(message.periodMeanUs);
    }
    if (message.periodMaxUs !== 0) {
      writer.uint32(56).uint64(message.periodMaxUs);
    }
    if (message.periodStddevUs !== 0) {
      writer.uint32(64).uint64(message.periodStddevUs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopicMetrics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopicMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.topic = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.msgCount = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.bytesTotal = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.latencyMeanUs = longToNumber(reader.uint64());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.latencyMaxUs = longToNumber(reader.uint64());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.periodMeanUs = longToNumber(reader.uint64());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.periodMaxUs = longToNumber(reader.uint64());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.periodStddevUs = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopicMetrics {
    return {
      topic: isSet(object.topic) ? globalThis.String(object.topic) : "",
      msgCount: isSet(object.msgCount) ? globalThis.Number(object.msgCount) : 0,
      bytesTotal: isSet(object.bytesTotal) ? globalThis.Number(object.bytesTotal) : 0,
      latencyMeanUs: isSet(object.latencyMeanUs) ? globalThis.Number(object.latencyMeanUs) : 0,
      latencyMaxUs: isSet(object.latencyMaxUs) ? globalThis.Number(object.latencyMaxUs) : 0,
      periodMeanUs: isSet(object.periodMeanUs) ? globalThis.Number(object.periodMeanUs) : 0,
      periodMaxUs: isSet(object.periodMaxUs) ? globalThis.Number(object.periodMaxUs) : 0,
      periodStddevUs: isSet(object.periodStddevUs) ? globalThis.Number(object.periodStddevUs) : 0,
    };
  },

  toJSON(message: TopicMetrics): unknown {
    const obj: any = {};
    if (message.topic !== "") {
      obj.topic = message.topic;
    }
    if (message.msgCount !== 0) {
      obj.msgCount = Math.round(message.msgCount);
    }
    if (message.bytesTotal !== 0) {
      obj.bytesTotal = Math.round(message.bytesTotal);
    }
    if (message.latencyMeanUs !== 0) {
      obj.latencyMeanUs = Math.round(message.latencyMeanUs);
    }
    if (message.latencyMaxUs !== 0) {
      obj.latencyMaxUs = Math.round(message.latencyMaxUs);
    }
    if (message.periodMeanUs !== 0) {
      obj.periodMeanUs = Math.round(message.periodMeanUs);
    }
    if (message.periodMaxUs !== 0) {
      obj.periodMaxUs = Math.round(message.periodMaxUs);
    }
    if (message.periodStddevUs !== 0) {
      obj.periodStddevUs = Math.round(message.periodStddevUs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopicMetrics>, I>>(base?: I): TopicMetrics {
    return TopicMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopicMetrics>, I>>(object: I): TopicMetrics {
    const message = createBaseTopicMetrics();
    message.topic = object.topic ?? "";
    message.msgCount = object.msgCount ?? 0;
    message.bytesTotal = object.bytesTotal ?? 0;
    message.latencyMeanUs = object.latencyMeanUs ?? 0;
    message.latencyMaxUs = object.latencyMaxUs ?? 0;
    message.periodMeanUs = object.periodMeanUs ?? 0;
    message.periodMaxUs = object.periodMaxUs ?? 0;
    message.periodStddevUs = object.periodStddevUs ?? 0;
    return message;
  },
};

function createBaseRequestMethodMetrics(): RequestMethodMetrics {
  return { method: "", msgCount: 0, bytesTotal: 0, latencyMeanUs: 0, latencyMaxUs: 0 };
}

export const RequestMethodMetrics: MessageFns<RequestMethodMetrics> = {
  encode(message: RequestMethodMetrics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.method !== "") {
      writer.uint32(10).string(message.method);
    }
    if (message.msgCount !== 0) {
      writer.uint32(16).uint64(message.msgCount);
    }
    if (message.bytesTotal !== 0) {
      writer.uint32(24).uint64(message.bytesTotal);
    }
    if (message.latencyMeanUs !== 0) {
      writer.uint32(32).uint64(message.latencyMeanUs);
    }
    if (message.latencyMaxUs !== 0) {
      writer.uint32(40).uint64(message.latencyMaxUs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequestMethodMetrics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestMethodMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.method = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.msgCount = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.bytesTotal = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.latencyMeanUs = longToNumber(reader.uint64());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.latencyMaxUs = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestMethodMetrics {
    return {
      method: isSet(object.method) ? globalThis.String(object.method) : "",
      msgCount: isSet(object.msgCount) ? globalThis.Number(object.msgCount) : 0,
      bytesTotal: isSet(object.bytesTotal) ? globalThis.Number(object.bytesTotal) : 0,
      latencyMeanUs: isSet(object.latencyMeanUs) ? globalThis.Number(object.latencyMeanUs) : 0,
      latencyMaxUs: isSet(object.latencyMaxUs) ? globalThis.Number(object.latencyMaxUs) : 0,
    };
  },

  toJSON(message: RequestMethodMetrics): unknown {
    const obj: any = {};
    if (message.method !== "") {
      obj.method = message.method;
    }
    if (message.msgCount !== 0) {
      obj.msgCount = Math.round(message.msgCount);
    }
    if (message.bytesTotal !== 0) {
      obj.bytesTotal = Math.round(message.bytesTotal);
    }
    if (message.latencyMeanUs !== 0) {
      obj.latencyMeanUs = Math.round(message.latencyMeanUs);
    }
    if (message.latencyMaxUs !== 0) {
      obj.latencyMaxUs = Math.round(message.latencyMaxUs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestMethodMetrics>, I>>(base?: I): RequestMethodMetrics {
    return RequestMethodMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestMethodMetrics>, I>>(object: I): RequestMethodMetrics {
    const message = createBaseRequestMethodMetrics();
    message.method = object.method ?? "";
    message.msgCount = object.msgCount ?? 0;
    message.bytesTotal = object.bytesTotal ?? 0;
    message.latencyMeanUs = object.latencyMeanUs ?? 0;
    message.latencyMaxUs = object.latencyMaxUs ?? 0;
    return message;
  },
};

function createBaseMessengerMetrics(): MessengerMetrics {
  return {
    nodeName: "",
    uptimeMs: 0,
    sinkPullers: [],
    sinkPushers: [],
    publishers: [],
    subscribers: [],
    reqSender: [],
    reqHandler: [],
    timeoutCount: 0,
  };
}

export const MessengerMetrics: MessageFns<MessengerMetrics> = {
  encode(message: MessengerMetrics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeName !== "") {
      writer.uint32(10).string(message.nodeName);
    }
    if (message.uptimeMs !== 0) {
      writer.uint32(16).uint64(message.uptimeMs);
    }
    for (const v of message.sinkPullers) {
      SinkMetrics.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.sinkPushers) {
      SinkMetrics.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.publishers) {
      TopicMetrics.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.subscribers) {
      TopicMetrics.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.reqSender) {
      RequestMethodMetrics.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.reqHandler) {
      RequestMethodMetrics.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.timeoutCount !== 0) {
      writer.uint32(72).uint64(message.timeoutCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessengerMetrics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessengerMetrics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.uptimeMs = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sinkPullers.push(SinkMetrics.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sinkPushers.push(SinkMetrics.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.publishers.push(TopicMetrics.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.subscribers.push(TopicMetrics.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.reqSender.push(RequestMethodMetrics.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.reqHandler.push(RequestMethodMetrics.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.timeoutCount = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessengerMetrics {
    return {
      nodeName: isSet(object.nodeName) ? globalThis.String(object.nodeName) : "",
      uptimeMs: isSet(object.uptimeMs) ? globalThis.Number(object.uptimeMs) : 0,
      sinkPullers: globalThis.Array.isArray(object?.sinkPullers)
        ? object.sinkPullers.map((e: any) => SinkMetrics.fromJSON(e))
        : [],
      sinkPushers: globalThis.Array.isArray(object?.sinkPushers)
        ? object.sinkPushers.map((e: any) => SinkMetrics.fromJSON(e))
        : [],
      publishers: globalThis.Array.isArray(object?.publishers)
        ? object.publishers.map((e: any) => TopicMetrics.fromJSON(e))
        : [],
      subscribers: globalThis.Array.isArray(object?.subscribers)
        ? object.subscribers.map((e: any) => TopicMetrics.fromJSON(e))
        : [],
      reqSender: globalThis.Array.isArray(object?.reqSender)
        ? object.reqSender.map((e: any) => RequestMethodMetrics.fromJSON(e))
        : [],
      reqHandler: globalThis.Array.isArray(object?.reqHandler)
        ? object.reqHandler.map((e: any) => RequestMethodMetrics.fromJSON(e))
        : [],
      timeoutCount: isSet(object.timeoutCount) ? globalThis.Number(object.timeoutCount) : 0,
    };
  },

  toJSON(message: MessengerMetrics): unknown {
    const obj: any = {};
    if (message.nodeName !== "") {
      obj.nodeName = message.nodeName;
    }
    if (message.uptimeMs !== 0) {
      obj.uptimeMs = Math.round(message.uptimeMs);
    }
    if (message.sinkPullers?.length) {
      obj.sinkPullers = message.sinkPullers.map((e) => SinkMetrics.toJSON(e));
    }
    if (message.sinkPushers?.length) {
      obj.sinkPushers = message.sinkPushers.map((e) => SinkMetrics.toJSON(e));
    }
    if (message.publishers?.length) {
      obj.publishers = message.publishers.map((e) => TopicMetrics.toJSON(e));
    }
    if (message.subscribers?.length) {
      obj.subscribers = message.subscribers.map((e) => TopicMetrics.toJSON(e));
    }
    if (message.reqSender?.length) {
      obj.reqSender = message.reqSender.map((e) => RequestMethodMetrics.toJSON(e));
    }
    if (message.reqHandler?.length) {
      obj.reqHandler = message.reqHandler.map((e) => RequestMethodMetrics.toJSON(e));
    }
    if (message.timeoutCount !== 0) {
      obj.timeoutCount = Math.round(message.timeoutCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MessengerMetrics>, I>>(base?: I): MessengerMetrics {
    return MessengerMetrics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MessengerMetrics>, I>>(object: I): MessengerMetrics {
    const message = createBaseMessengerMetrics();
    message.nodeName = object.nodeName ?? "";
    message.uptimeMs = object.uptimeMs ?? 0;
    message.sinkPullers = object.sinkPullers?.map((e) => SinkMetrics.fromPartial(e)) || [];
    message.sinkPushers = object.sinkPushers?.map((e) => SinkMetrics.fromPartial(e)) || [];
    message.publishers = object.publishers?.map((e) => TopicMetrics.fromPartial(e)) || [];
    message.subscribers = object.subscribers?.map((e) => TopicMetrics.fromPartial(e)) || [];
    message.reqSender = object.reqSender?.map((e) => RequestMethodMetrics.fromPartial(e)) || [];
    message.reqHandler = object.reqHandler?.map((e) => RequestMethodMetrics.fromPartial(e)) || [];
    message.timeoutCount = object.timeoutCount ?? 0;
    return message;
  },
};

/** @language: typescript,python */
export interface DefaultService {
  Ping(request: PingRequest): Promise<PingResponse>;
  GetServiceInfo(request: ServiceInfoRequest): Promise<ServiceInfoResponse>;
}

export const DefaultServiceServiceName = "messenger.DefaultService";
export class DefaultServiceClientImpl implements DefaultService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || DefaultServiceServiceName;
    this.rpc = rpc;
    this.Ping = this.Ping.bind(this);
    this.GetServiceInfo = this.GetServiceInfo.bind(this);
  }
  Ping(request: PingRequest): Promise<PingResponse> {
    const data = PingRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "Ping", data);
    return promise.then((data) => PingResponse.decode(new BinaryReader(data)));
  }

  GetServiceInfo(request: ServiceInfoRequest): Promise<ServiceInfoResponse> {
    const data = ServiceInfoRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetServiceInfo", data);
    return promise.then((data) => ServiceInfoResponse.decode(new BinaryReader(data)));
  }
}

/** @language: typescript, python, cpp, go */
export interface DefaultTopics {
  __metrics__(request: MessengerMetrics): Promise<Empty>;
}

export const DefaultTopicsServiceName = "messenger.DefaultTopics";
export class DefaultTopicsClientImpl implements DefaultTopics {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || DefaultTopicsServiceName;
    this.rpc = rpc;
    this.__metrics__ = this.__metrics__.bind(this);
  }
  __metrics__(request: MessengerMetrics): Promise<Empty> {
    const data = MessengerMetrics.encode(request).finish();
    const promise = this.rpc.request(this.service, "__metrics__", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type ProtoMetaMessageOptions = {
  options?: { [key: string]: any };
  fields?: { [key: string]: { [key: string]: any } };
  oneof?: { [key: string]: { [key: string]: any } };
  nested?: { [key: string]: ProtoMetaMessageOptions };
};

export interface ProtoMetadata {
  fileDescriptor: FileDescriptorProto1;
  references: { [key: string]: any };
  dependencies?: ProtoMetadata[];
  options?: {
    options?: { [key: string]: any };
    services?: {
      [key: string]: { options?: { [key: string]: any }; methods?: { [key: string]: { [key: string]: any } } };
    };
    messages?: { [key: string]: ProtoMetaMessageOptions };
    enums?: { [key: string]: { options?: { [key: string]: any }; values?: { [key: string]: { [key: string]: any } } } };
  };
}

export const protoMetadata: ProtoMetadata = {
  fileDescriptor: {
    "name": "messenger/messenger.proto",
    "package": "messenger",
    "dependency": ["google/protobuf/empty.proto"],
    "publicDependency": [],
    "weakDependency": [],
    "messageType": [{
      "name": "Envelope",
      "field": [{
        "name": "message_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "messageId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "message_type",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "messageType",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "communication_type",
        "number": 3,
        "label": 1,
        "type": 14,
        "typeName": ".messenger.CommunicationType",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "communicationType",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "payload",
        "number": 4,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "payload",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "timestamp_us",
        "number": 5,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "timestampUs",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ServiceInfo",
      "field": [{
        "name": "service_key",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "serviceKey",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "request_port",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "requestPort",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "message_types",
        "number": 3,
        "label": 3,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "messageTypes",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "topic_port",
        "number": 4,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "topicPort",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "topic_types",
        "number": 5,
        "label": 3,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "topicTypes",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "providers",
        "number": 6,
        "label": 3,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "providers",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "sink_port",
        "number": 7,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "sinkPort",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ClientOptions",
      "field": [{
        "name": "config_path",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "configPath",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "registry_port",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "registryPort",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_config_path", "options": undefined }, {
        "name": "_registry_port",
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ErrorResponse",
      "field": [{
        "name": "error",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SinkEnvelope",
      "field": [{
        "name": "topic",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "topic",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "sender_id",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "senderId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "payload",
        "number": 3,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "payload",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "timestamp_us",
        "number": 4,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "timestampUs",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TopicEnvelope",
      "field": [{
        "name": "payload",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "payload",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "timestamp_us",
        "number": 2,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "timestampUs",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RequestTarget",
      "field": [{
        "name": "host",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "host",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "service_key",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "serviceKey",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_host", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PingRequest",
      "field": [],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PingResponse",
      "field": [{
        "name": "pong",
        "number": 1,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "pong",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ServiceInfoRequest",
      "field": [],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ServiceInfoResponse",
      "field": [{
        "name": "service_info",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".messenger.ServiceInfo",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "serviceInfo",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SinkMetrics",
      "field": [{
        "name": "topic",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "topic",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "msg_count",
        "number": 2,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "msgCount",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "bytes_total",
        "number": 3,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "bytesTotal",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "send_failures",
        "number": 4,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "sendFailures",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "latency_mean_us",
        "number": 5,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "latencyMeanUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "latency_max_us",
        "number": 6,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "latencyMaxUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "period_mean_us",
        "number": 7,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "periodMeanUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "period_max_us",
        "number": 8,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "periodMaxUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "period_stddev_us",
        "number": 9,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "periodStddevUs",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TopicMetrics",
      "field": [{
        "name": "topic",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "topic",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "msg_count",
        "number": 2,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "msgCount",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "bytes_total",
        "number": 3,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "bytesTotal",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "latency_mean_us",
        "number": 4,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "latencyMeanUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "latency_max_us",
        "number": 5,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "latencyMaxUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "period_mean_us",
        "number": 6,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "periodMeanUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "period_max_us",
        "number": 7,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "periodMaxUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "period_stddev_us",
        "number": 8,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "periodStddevUs",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RequestMethodMetrics",
      "field": [{
        "name": "method",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "method",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "msg_count",
        "number": 2,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "msgCount",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "bytes_total",
        "number": 3,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "bytesTotal",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "latency_mean_us",
        "number": 4,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "latencyMeanUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "latency_max_us",
        "number": 5,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "latencyMaxUs",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "MessengerMetrics",
      "field": [{
        "name": "node_name",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "nodeName",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "uptime_ms",
        "number": 2,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "uptimeMs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "sink_pullers",
        "number": 3,
        "label": 3,
        "type": 11,
        "typeName": ".messenger.SinkMetrics",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "sinkPullers",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "sink_pushers",
        "number": 4,
        "label": 3,
        "type": 11,
        "typeName": ".messenger.SinkMetrics",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "sinkPushers",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "publishers",
        "number": 5,
        "label": 3,
        "type": 11,
        "typeName": ".messenger.TopicMetrics",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "publishers",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "subscribers",
        "number": 6,
        "label": 3,
        "type": 11,
        "typeName": ".messenger.TopicMetrics",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "subscribers",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "req_sender",
        "number": 7,
        "label": 3,
        "type": 11,
        "typeName": ".messenger.RequestMethodMetrics",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "reqSender",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "req_handler",
        "number": 8,
        "label": 3,
        "type": 11,
        "typeName": ".messenger.RequestMethodMetrics",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "reqHandler",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "timeout_count",
        "number": 9,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "timeoutCount",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "enumType": [{
      "name": "CommunicationType",
      "value": [
        { "name": "ERROR", "number": 0, "options": undefined },
        { "name": "REQUEST", "number": 1, "options": undefined },
        { "name": "REPLY", "number": 2, "options": undefined },
        { "name": "PUBLISH", "number": 3, "options": undefined },
        { "name": "SUBSCRIBE", "number": 4, "options": undefined },
        { "name": "STREAM", "number": 5, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DefaultRequests",
      "value": [{ "name": "Ping", "number": 0, "options": undefined }, {
        "name": "GetServiceInfo",
        "number": 1,
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "service": [{
      "name": "DefaultService",
      "method": [{
        "name": "Ping",
        "inputType": ".messenger.PingRequest",
        "outputType": ".messenger.PingResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "GetServiceInfo",
        "inputType": ".messenger.ServiceInfoRequest",
        "outputType": ".messenger.ServiceInfoResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }, {
      "name": "DefaultTopics",
      "method": [{
        "name": "__metrics__",
        "inputType": ".messenger.MessengerMetrics",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }],
    "extension": [],
    "options": {
      "javaPackage": "",
      "javaOuterClassname": "",
      "javaMultipleFiles": false,
      "javaGenerateEqualsAndHash": false,
      "javaStringCheckUtf8": false,
      "optimizeFor": 1,
      "goPackage": "sb.app/messenger/proto/common",
      "ccGenericServices": false,
      "javaGenericServices": false,
      "pyGenericServices": false,
      "phpGenericServices": false,
      "deprecated": false,
      "ccEnableArenas": true,
      "objcClassPrefix": "",
      "csharpNamespace": "",
      "swiftPrefix": "",
      "phpClassPrefix": "",
      "phpNamespace": "",
      "phpMetadataNamespace": "",
      "rubyPackage": "",
      "uninterpretedOption": [],
    },
    "sourceCodeInfo": {
      "location": [{
        "path": [4, 0],
        "span": [7, 0, 13, 1],
        "leadingComments": " Generic message envelope for routing and metadata\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 4],
        "span": [35, 0, 40, 1],
        "leadingComments":
          " Envelope for sink (PUSH/PULL) messages — packs metadata + payload into a single ZMQ frame\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5],
        "span": [43, 0, 46, 1],
        "leadingComments": " Envelope for PUB/SUB messages — wraps payload with a send timestamp\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 0],
        "span": [54, 0, 61, 1],
        "leadingComments": " Communication patterns supported\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 0],
        "span": [81, 0, 84, 1],
        "leadingComments": " @language: typescript,python\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 13],
        "span": [114, 0, 120, 1],
        "leadingComments": " Per-method request metrics (used for both sender and handler).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 1],
        "span": [135, 0, 137, 1],
        "leadingComments": " @language: typescript, python, cpp, go\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }],
    },
    "syntax": "proto3",
  },
  references: {
    ".messenger.CommunicationType": CommunicationType,
    ".messenger.DefaultRequests": DefaultRequests,
    ".messenger.Envelope": Envelope,
    ".messenger.ServiceInfo": ServiceInfo,
    ".messenger.ClientOptions": ClientOptions,
    ".messenger.ErrorResponse": ErrorResponse,
    ".messenger.SinkEnvelope": SinkEnvelope,
    ".messenger.TopicEnvelope": TopicEnvelope,
    ".messenger.RequestTarget": RequestTarget,
    ".messenger.PingRequest": PingRequest,
    ".messenger.PingResponse": PingResponse,
    ".messenger.ServiceInfoRequest": ServiceInfoRequest,
    ".messenger.ServiceInfoResponse": ServiceInfoResponse,
    ".messenger.SinkMetrics": SinkMetrics,
    ".messenger.TopicMetrics": TopicMetrics,
    ".messenger.RequestMethodMetrics": RequestMethodMetrics,
    ".messenger.MessengerMetrics": MessengerMetrics,
    ".messenger.DefaultService": DefaultServiceClientImpl,
    ".messenger.DefaultTopics": DefaultTopicsClientImpl,
  },
  dependencies: [protoMetadata1],
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
